import { SVGProps } from "react";

export function Calculator(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.818 19.536C4.136 21 6.258 21 10.5 21C14.742 21 16.864 21 18.182 19.535C19.5 18.072 19.5 15.714 19.5 11C19.5 6.286 19.5 3.929 18.182 2.464C16.864 0.999 14.742 1 10.5 1C6.258 1 4.136 1 2.818 2.464C1.5 3.93 1.5 6.286 1.5 11C1.5 15.714 1.5 18.072 2.818 19.536Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M5.5 7C5.5 6.535 5.5 6.303 5.551 6.112C5.61919 5.85787 5.75303 5.62614 5.93909 5.44009C6.12514 5.25403 6.35687 5.12019 6.611 5.052C6.804 5 7.036 5 7.5 5H13.5C13.965 5 14.197 5 14.388 5.051C14.6421 5.11919 14.8739 5.25303 15.0599 5.43909C15.246 5.62514 15.3798 5.85687 15.448 6.111C15.5 6.304 15.5 6.536 15.5 7C15.5 7.464 15.5 7.697 15.449 7.888C15.3808 8.14213 15.247 8.37386 15.0609 8.55991C14.8749 8.74597 14.6431 8.87981 14.389 8.948C14.197 9 13.964 9 13.5 9H7.5C7.035 9 6.803 9 6.612 8.949C6.35787 8.88081 6.12614 8.74697 5.94009 8.56091C5.75403 8.37486 5.62019 8.14313 5.552 7.889C5.5 7.696 5.5 7.464 5.5 7Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M6.5 13C7.05228 13 7.5 12.5523 7.5 12C7.5 11.4477 7.05228 11 6.5 11C5.94772 11 5.5 11.4477 5.5 12C5.5 12.5523 5.94772 13 6.5 13Z"
        fill="currentColor"
      />
      <path
        d="M6.5 17C7.05228 17 7.5 16.5523 7.5 16C7.5 15.4477 7.05228 15 6.5 15C5.94772 15 5.5 15.4477 5.5 16C5.5 16.5523 5.94772 17 6.5 17Z"
        fill="currentColor"
      />
      <path
        d="M10.5 13C11.0523 13 11.5 12.5523 11.5 12C11.5 11.4477 11.0523 11 10.5 11C9.94772 11 9.5 11.4477 9.5 12C9.5 12.5523 9.94772 13 10.5 13Z"
        fill="currentColor"
      />
      <path
        d="M10.5 17C11.0523 17 11.5 16.5523 11.5 16C11.5 15.4477 11.0523 15 10.5 15C9.94772 15 9.5 15.4477 9.5 16C9.5 16.5523 9.94772 17 10.5 17Z"
        fill="currentColor"
      />
      <path
        d="M14.5 13C15.0523 13 15.5 12.5523 15.5 12C15.5 11.4477 15.0523 11 14.5 11C13.9477 11 13.5 11.4477 13.5 12C13.5 12.5523 13.9477 13 14.5 13Z"
        fill="currentColor"
      />
      <path
        d="M14.5 17C15.0523 17 15.5 16.5523 15.5 16C15.5 15.4477 15.0523 15 14.5 15C13.9477 15 13.5 15.4477 13.5 16C13.5 16.5523 13.9477 17 14.5 17Z"
        fill="currentColor"
      />
    </svg>
  );
}
